import { useState, ComponentType } from 'react'
import { Button } from '@/components/Button'
import { ButtonSandbox } from './ButtonSandbox'
import { CalendarSandbox } from './CalendarSandbox'
import { CommunityCardSandbox } from './CommunityCardSandbox'
import { CommunityInfoSandbox } from './CommunityInfoSandbox'
import { FilterButtonSandbox } from './FilterButtonSandbox'
import { TagSandbox } from './TagSandbox'
import { ToggleButtonGroupSandbox } from './ToggleButtonGroupSandbox'
import { FilterContentSandbox } from './FilterContentSandbox'
import { ListItemSandbox } from './ListItemSandbox'
import { DateFieldSandbox } from './DateFieldSandbox'
import { NumberFieldSandbox } from './NumberFieldSandbox'
import { SelectFieldSandbox } from './SelectFieldSandbox'
import { SkeletonCardSandbox } from './SkeletonCardSandbox'
import { TooltipSandbox } from './TooltipSandbox'
import { LinkSandbox } from './LinkSandbox'
import { PlanCardSandbox } from './PlanCardSandbox'
import { PricingPanelSandbox } from './PricingPanelSandbox'
import { UnitCardSandbox } from './UnitCardSandbox'
import { UnitListButtonSandbox } from './UnitListButtonSandbox'

type SandboxEntry = {
	label: string
	component: ComponentType
}

const registry: SandboxEntry[] = [
	{ label: 'Button', component: ButtonSandbox },
	{ label: 'Calendar', component: CalendarSandbox },
	{ label: 'CommunityCard', component: CommunityCardSandbox },
	{ label: 'CommunityInfo', component: CommunityInfoSandbox },
	{ label: 'DateField', component: DateFieldSandbox },
	{ label: 'FilterButton', component: FilterButtonSandbox },
	{ label: 'FilterContent', component: FilterContentSandbox },
	{ label: 'Link', component: LinkSandbox },
	{ label: 'ListItem', component: ListItemSandbox },
	{ label: 'NumberField', component: NumberFieldSandbox },
	{ label: 'PlanCard', component: PlanCardSandbox },
	{ label: 'PricingPanel', component: PricingPanelSandbox },
	{ label: 'SelectField', component: SelectFieldSandbox },
	{ label: 'SkeletonCard', component: SkeletonCardSandbox },
	{ label: 'Tag', component: TagSandbox },
	{ label: 'ToggleButtonGroup', component: ToggleButtonGroupSandbox },
	{ label: 'Tooltip', component: TooltipSandbox },
	{ label: 'UnitCard', component: UnitCardSandbox },
	{ label: 'UnitListButton', component: UnitListButtonSandbox }
]

export function ComponentSandbox ({ onExit }: { onExit: () => void }) {
	const [active, setActive] = useState(0)
	const ActiveComponent = registry[active].component

	return (
		<div className='spaces:flex spaces:h-screen spaces:overflow-hidden spaces:bg-canvas-base'>
			{/* Left-hand nav */}
			<aside className='spaces:flex spaces:flex-col spaces:w-200 spaces:shrink-0 spaces:border-r spaces:border-canvas-3 spaces:bg-canvas-base'>
				{/* Sidebar header */}
				<div className='spaces:flex spaces:flex-col spaces:gap-4 spaces:p-16 spaces:border-b spaces:border-canvas-3'>
					<Button
						appearance='ghost'
						color='content2'
						size='sm'
						iconLeft='ArrowLeft'
						label='Back to Spaces'
						onClick={onExit}
					/>
					<span className='spaces:text-12 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide spaces:px-8 spaces:pt-4'>
						Components
					</span>
				</div>

				{/* Nav items */}
				<nav className='spaces:flex spaces:flex-col spaces:gap-2 spaces:p-8 spaces:overflow-y-auto'>
					{registry.map((entry, i) => (
						<button
							key={entry.label}
							onClick={() => setActive(i)}
							className={`spaces:text-left spaces:text-14 spaces:font-default spaces:rounded-8 spaces:px-12 spaces:py-8 spaces:transition-colors ${
								i === active
									? 'spaces:bg-brand-subtle spaces:text-brand-on-subtle'
									: 'spaces:text-content-2 spaces:hover:bg-canvas-2'
							}`}
						>
							{entry.label}
						</button>
					))}
				</nav>
			</aside>

			{/* Main content */}
			<main className='spaces:flex spaces:flex-col spaces:flex-1 spaces:overflow-y-auto'>
				<div className='spaces:p-32'>
					<h2 className='spaces:text-24 spaces:font-semi spaces:text-content-1 spaces:mb-24'>
						{registry[active].label}
					</h2>
					<ActiveComponent />
				</div>
			</main>
		</div>
	)
}
